import { render, staticRenderFns } from "./myButton.vue?vue&type=template&id=12a2dea2&scoped=true&"
import script from "./myButton.vue?vue&type=script&lang=js&"
export * from "./myButton.vue?vue&type=script&lang=js&"
import style0 from "./myButton.vue?vue&type=style&index=0&id=12a2dea2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a2dea2",
  null
  
)

export default component.exports